import React, { useEffect, useState } from 'react';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { IncludesSection } from './components/IncludesSection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsCompact } from './components/TestimonialsCompact';
import { FooterCTA } from './components/FooterCTA';
import { PopNotifications } from './components/upsell/PopNotifications';
import { UpsellPage } from './pages/UpsellPage';
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.hash);
  useEffect(() => {
    initMetaPixel('26472237642370868');
    trackPageView();
    const handleHashChange = () => {
      setCurrentPath(window.location.hash);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  if (currentPath === '#upsell') {
    return <UpsellPage data-id="element-0" />;
  }
  return <div className="min-h-screen w-full font-body text-text-dark selection:bg-sage/30 relative" data-id="element-1">
      {/* Fixed blurred background image behind all sections */}
      <div className="fixed inset-0 z-0 pointer-events-none" data-id="element-2">
        <img src="https://cdn.magicpatterns.com/uploads/muAyBqLc7bCQndZz9V3uJY/Portada_libro.png" alt="" className="w-full h-full object-cover scale-110 blur-xl" data-id="element-3" />
        <div className="absolute inset-0 bg-[#F2E8DA]/30" data-id="element-4"></div>
      </div>

      <div className="relative z-10" data-id="element-5">
        <HeroSection data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <SolutionSection data-id="element-8" />
        <BenefitsSection data-id="element-9" />
        <IncludesSection data-id="element-10" />
        <OfferSection data-id="element-11" />
        <TestimonialsCompact data-id="element-12" />
        <FooterCTA data-id="element-13" />
        <PopNotifications data-id="element-14" />
      </div>
    </div>;
}